export default {
  lineNumberColor: `#D8DEE9`,
  lineNumberBgColor: `#2E3440`,
  backgroundColor: `#2E3440`,
  textColor: `#D8DEE9`,
  substringColor: `#D8DEE9`,
  keywordColor: `#81A1C1`,
  attributeColor: `#D8DEE9`,
  selectorAttributeColor: `#81A1C1`,
  docTagColor: `#8FBCBB`,
  nameColor: `#81A1C1`,
  builtInColor: `#8FBCBB`,
  literalColor: `#81A1C1`,
  bulletColor: `#81A1C1`,
  codeColor: `#8FBCBB`,
  additionColor: `#a3be8c`,
  regexpColor: `#EBCB8B`,
  symbolColor: `#81A1C1`,
  variableColor: `#D8DEE9`,
  templateVariableColor: `#D8DEE9`,
  linkColor: `#D8DEE9`,
  selectorClassColor: `#8FBCBB`,
  typeColor: `#8FBCBB`,
  stringColor: `#A3BE8C`,
  selectorIdColor: `#8FBCBB`,
  quoteColor: `#4C566A`,
  templateTagColor: `#5E81AC`,
  deletionColor: `#bf616a`,
  titleColor: `#8FBCBB`,
  sectionColor: `#88C0D0`,
  commentColor: `#4C566A`,
  metaKeywordColor: `#5E81AC`,
  metaColor: `#5E81AC`,
  functionColor: `#88C0D0`,
  numberColor: `#B48EAD`,
}
